/* Refillia: il conto alla rovescia delle offerte, un giro di 7 giorni uguale per tutti che riparte da solo */
(function () {
  var GIRO = 7 * 86400000;
  var PRIMA_FINE = Date.parse('2026-10-05T23:59:59+02:00');
  window.RF_FINE_OFFERTE = function (iso) {
    var fissa = iso ? Date.parse(iso) : NaN;
    if (!isNaN(fissa) && fissa > Date.now()) return fissa;
    var ora = Date.now();
    var k = Math.ceil((ora - PRIMA_FINE) / GIRO);
    var fine = PRIMA_FINE + k * GIRO;
    if (fine <= ora) fine += GIRO;
    return fine;
  };
  function due(n) { return n < 10 ? '0' + n : '' + n; }

  function avvia(box) {
    if (box.dataset.rfAvviata) return;
    box.dataset.rfAvviata = '1';
    var fine = window.RF_FINE_OFFERTE(box.dataset.rfIso);
    var orologi = box.querySelectorAll('[data-rf-orologio]');
    if (!orologi.length) return;

    function giro() {
      var resto = fine - Date.now();
      if (resto <= 0) { fine = window.RF_FINE_OFFERTE(''); resto = fine - Date.now(); }
      var g = Math.floor(resto / 86400000);
      var o = Math.floor(resto / 3600000) % 24;
      var m = Math.floor(resto / 60000) % 60;
      var s = Math.floor(resto / 1000) % 60;
      for (var i = 0; i < orologi.length; i++) {
        var e = orologi[i];
        if (e.children.length === 7) {
          e.children[0].textContent = g;
          e.children[2].textContent = due(o);
          e.children[4].textContent = due(m);
          e.children[6].textContent = due(s);
        } else {
          e.textContent = g + 'g ' + due(o) + ':' + due(m) + ':' + due(s);
        }
      }
    }

    giro();
    setInterval(giro, 1000);
  }

  function tutte() {
    var lista = document.querySelectorAll('[data-rf-fine]');
    for (var i = 0; i < lista.length; i++) avvia(lista[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
